/* eslint-disable import/named */
import React from 'react';
import scrollTo from 'gatsby-plugin-smoothscroll';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  InnerBanner,
  IframeVideo,
  BannerDescription,
  BannerHeading,
  BannerP,
  HeroSearch,
  SearchSpan,
} from './styles/InnerPageBanner.styled';

export default function BannerWithSearchBar({ data, id, dir }) {
  const { title, image, videoUrl, description, searchBarTitle } = data;
  return (
    <InnerBanner className="video_section" id={id}>
      {videoUrl ? (
        <IframeVideo>
          <iframe
            title="vimeo"
            tabIndex="-1"
            src={videoUrl}
            className="vm-source"
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen=""
            data-deferred="true"
          />
        </IframeVideo>
      ) : (
        <LazyLoadImage
          src={image.url}
          alt={title}
          className="inner_bnr"
          placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
          effect="blur"
        />
      )}
      <BannerDescription>
        <BannerHeading dir={dir}>Industry Insights</BannerHeading>
        <BannerP dir={dir}>{description}</BannerP>
        <HeroSearch>
          <input
            type="text"
            dir={dir}
            className="searchinput"
            placeholder="What are you interested in?"
          />
          <button type="button" dir={dir} className="sb-search-submit">
            <span>{searchBarTitle}</span>
          </button>
          <SearchSpan>&nbsp;</SearchSpan>
        </HeroSearch>
      </BannerDescription>
      <button
        type="button"
        dir={dir}
        onClick={() => scrollTo('#socialmedia')}
        className="scr-down bounce"
      >
        <span />
      </button>
    </InnerBanner>
  );
}
